module.exports = __webpack_public_path__ + "static/media/shoes.5cb6225f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shoes.jpg
// module id = 109
// module chunks = 0